/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Something_Went_WrongInputs */



/**
* | output |
* | --- |
* | "Something went wrong!" |
*
* @param {Something_Went_WrongInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const something_went_wrong = /** @type {((inputs?: Something_Went_WrongInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Something_Went_WrongInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Something went wrong!")
	return /** @type {LocalizedString} */ ("Någonting gick fel!")
});